// Fields that hold numeric values and thus require less space
const NUMERIC_FIELDS = [
    "quantity",
    "unit_price",
    "amount",
    "discount_amount",
    "ex_vat_amount",
    "incl_vat_amount",
    "unit_of_measure",
    "discount_percentage",
    "article_number"
];

// Fields that hold (potentially) long values and thus require more space
const WIDE_FIELDS = [
    "description"
];

const pct = (v: number) => `${v}%`;
const getDefaultColumnWidth = (numberOfColumns: number) => 100 / numberOfColumns;
const getNumericColumnWidth = (numberOfColumns: number) => getDefaultColumnWidth(numberOfColumns) / 1.5;

const isWideColumn = (columnName: string) => WIDE_FIELDS.includes(columnName)
const isNumericColumn = (columnName: string) => NUMERIC_FIELDS.includes(columnName);

export const getColumnWidthsFn = (numberOfColumns: number) => {
    return (columnName: string) => {
        if (isWideColumn(columnName)) return "auto";
        if (isNumericColumn(columnName)) return pct(getNumericColumnWidth(numberOfColumns));

        return pct(getDefaultColumnWidth(numberOfColumns));
    }
}